export enum CONSENT_DOCUMENT_VERIFICATION_OUTCOME {
	success = "success",
	failure = "failure",
}

export enum TARIFF_STATUS {
	details_missing = "details_missing",
	not_ready_to_switch = "not_ready_to_switch",
	ready_to_switch = "ready_to_switch",
	bundling = "bundling",
	offer_received = "offer_received",
	confirming_offer = "confirming_offer",
	offer_accepted = "offer_accepted",
	offer_declined = "offer_declined",
	offer_rejected = "offer_rejected",
	offer_confirmed = "offer_confirmed",
}

export const FREE_ENERGY_AUDIT_OFFER_EXPIRY_DATE = new Date("2025-04-28");

export const INDUSTRIES = [
	{
		label: "Restaurant",
		reviewStageTitle: "How restaurant businesses like yours use energy",
		energyUsePercDiffDuringPeakHours: 1.2,
	},
	{
		label: "Coffee shop",
		reviewStageTitle: "How coffee shops like yours use energy",
		energyUsePercDiffDuringPeakHours: 12.0,
	},
	{
		label: "Retail and wholesale",
		reviewStageTitle:
			"How businesses like yours in the retail and wholesale industry use energy",
		energyUsePercDiffDuringPeakHours: 7.3,
	},
	{
		label: "Office block",
		reviewStageTitle: "How office blocks like yours use energy",
		energyUsePercDiffDuringPeakHours: 7.5,
	},
	{
		label: "Manufacturing",
		reviewStageTitle:
			"How businesses like yours in the manufacturing industry use energy",
		energyUsePercDiffDuringPeakHours: 9.7,
	},
	{
		label: "Other small business",
		reviewStageTitle: "How the average small business like yours uses energy",
		energyUsePercDiffDuringPeakHours: 7.5,
	},
];
